var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box right"},[_c('div',{staticClass:"banner-top"},[_c('img',{staticClass:"banner",attrs:{"src":require(("@/static/img/" + _vm.preExamCategory + "/banner.png"))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }